// log version to console
// import './version';
// import local dependencies
import Banner from './common/banner.ts';
import Footer from './common/footer.ts';
import Labels from './common/labels.ts';
import Nav from './common/navigation.ts';
import Search from './common/search.ts';
import Buttons from './common/buttons.ts';
import Formidable from './forms/formidable';

window.addEventListener('load', () => {
	// Header (Banner) features

	// Header-top getting hidden on scroll is causing CLS issues, so we're testing
	// keeping it visible on scroll.
	// Banner();

	// Main Navigation
	Nav();

	// Footer Accordion
	Footer();

	// Banner Search
	Search();

	// Floating Form Labels & Focus States
	Labels();

	// Add a11y behavior to buttons
	Buttons();

	// Add input mask to phone field on Formidable forms
	const FormidablePhoneField = document.querySelector(
		'.frm_form_field input[type="tel"]'
	);
	if (FormidablePhoneField) {
		Formidable(FormidablePhoneField);
	}
});
